import { render } from "./BookingLayout.vue?vue&type=template&id=10071355"
import script from "./BookingLayout.vue?vue&type=script&lang=js"
export * from "./BookingLayout.vue?vue&type=script&lang=js"
script.render = render

export default script